import { defineStore } from "pinia"

interface msgType {
  ackMsgList: string[] // 用户端回复的ack消息，用于判断用户是否已经回复过
  alertStatus: boolean // 断网后控制提示弹框的状态
  loadingStatus: boolean // 断网后控制加载弹框的状态
  messageHandlersList: Record<string, (msg: any) => Promise<boolean>>
}

export const useMsgStore = defineStore("msgStore", {
  state: (): msgType => ({
    ackMsgList: [],
    alertStatus: false,
    loadingStatus: false,
    messageHandlersList: {},
  }),
  actions: {
    addAckMsg(msg: string) {
      this.ackMsgList.push(msg)
    },
    changeLoadingStatus(status: boolean) {
      this.loadingStatus = status
    },
    changeAlertStatus(status: boolean) {
      this.alertStatus = status
    },
    addMessageHandler(type: string, handler: (msg: any) => Promise<boolean>) {
      this.messageHandlersList[type] = handler
    },
    removeMessageHandler(type: string) {
      delete this.messageHandlersList[type]
    },

    runMessageHandler(type: string, msg: any) {
      return new Promise((resolve, reject) => {
        console.log(this.messageHandlersList)
        const handler = this.messageHandlersList[type]
        // console.log(handler, "handler")
        if (handler) {
          handler(msg)
            .then(() => {
              if (msg.fn !== "receiveMousePosition") {
                console.log("ok", type, msg.fn)
              }
              resolve(true)
            })
            .catch((e) => {
              if (msg.fn !== "receiveMousePosition") {
                console.log("error", type, msg.fn, e)
              }
              resolve(false)
            })
        } else {
          reject(false)
        }
      }).catch((e) => {})
    },
  },
})
